<script setup>
  /* global defineProps, defineEmits */
  import { toRef } from 'vue'
  import { useMeetingReplayPolicy } from '../../composables/useMeetingReplayPolicy'
  const props = defineProps({ meetingCode: { type: String, required: true } })
  const emit = defineEmits(['changed'])
  const {
    meetingPolicy,
    meetingLoading,
    meetingSaving,
    meetingError,
    meetingVersionConflict,
    refresh,
    saveMeetingPolicy,
  } = useMeetingReplayPolicy(toRef(props, 'meetingCode'), { canManageMeetingPolicy: true })
  const save = async (mode) => {
    try {
      if (await saveMeetingPolicy(mode)) emit('changed')
    } catch (error) {
      // The composable exposes the failure and refreshes conflicts.
    }
  }
</script>
<template>
  <div class="replay-policy">
    <label v-if="meetingPolicy">
      自动生成
      <select
        :disabled="meetingLoading || meetingSaving"
        :value="meetingPolicy.meetingOverrideMode"
        @change="save($event.target.value)"
      >
        <option value="INHERIT">沿用企业设置</option>
        <option value="AUTO">整场会议结束后自动生成</option>
        <option value="MANUAL_ONLY">仅手动生成</option>
      </select>
    </label>
    <span v-if="meetingPolicy && !meetingPolicy.globalAutoTriggerEnabled">自动生成服务尚未开启，手动生成可用。</span>
    <span v-if="meetingVersionConflict">设置已更新，请重新选择。</span>
    <span v-else-if="meetingError">
      自动生成设置加载或保存失败。
      <button type="button" @click="refresh()">重试</button>
    </span>
  </div>
</template>
<style scoped>
  .replay-policy {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 16px;
    font-size: 13px;
    color: #606266;
  }
  select {
    margin-left: 10px;
    padding: 6px 8px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fff;
  }
</style>
